import {
  UPDATE_TRANSLATION,
  SET_MODIFIED_TRANSLATIONS,
  ADD_FAQ_ROW
} from '../actionTypes'

export const updateTranslation = (lang, topic, key, value, path) => {
  return dispatch => {
    dispatch({
      type: UPDATE_TRANSLATION,
      lang,
      topic,
      key,
      value,
      path
    })
  }
}

export const setModifiedTranslations = () => {
  return (dispatch, getState) => {
    const { translations } = getState().i18n

    dispatch({
      type: SET_MODIFIED_TRANSLATIONS,
      translations
    })
  }
}

export const addFaqRow = lang => ({
  type: ADD_FAQ_ROW,
  lang
})
